import { faPrint } from '@fortawesome/free-solid-svg-icons';
export const PrintButton = {
    key: 'print',
    buttonStyle: 'default-1',
    icon: faPrint,
    section: 'middle',
    prio: 10,
    text: 'Skriv ut',
    defaultRules: [],
    onClick: async (row, inca)=>{
        inca.errand.print();
    }
};
